import { ServiceLogoCannon } from '@puffin/ui-library';
import { dismissTaskCompletedAnimation, useTaskCompletedAnimations } from '../../state/notifications/task-completed-animation';

/** Keep a single completion celebration alive across route changes. */
export const TaskCompletedAnimationCenter = () => {
  const pending = useTaskCompletedAnimations((state) => state.pending);

  return pending ? <ServiceLogoCannon autoPlay onComplete={dismissTaskCompletedAnimation} /> : null;
};
